import { useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import {
  showBrowserNotification,
  subscribeForegroundPush,
  syncPushTokenAfterAuth,
} from '../services/pushMessaging';
import { isNotificationGranted } from '../utils/pwaEnvironment';

/** Sync FCM after login and show tray notifications when the PWA is open. */
export function PushMessagingBootstrap() {
  const { isAuthenticated, token } = useAuth();

  useEffect(() => {
    if (!isAuthenticated || !token) return;
    void syncPushTokenAfterAuth();
  }, [isAuthenticated, token]);

  useEffect(() => {
    if (!isAuthenticated) return;
    if (!isNotificationGranted()) return;
    return subscribeForegroundPush(({ title, body, data }) => {
      void showBrowserNotification(title, body, data);
    });
  }, [isAuthenticated]);

  return null;
}

/** Remove web push token when session ends (keeps user preference for next login). */
export async function onAuthLogoutPushCleanup(): Promise<void> {
  const { unregisterDeviceTokenFromApi } = await import('../services/pushMessaging');
  await unregisterDeviceTokenFromApi();
}
